// extracted by mini-css-extract-plugin
export default {"activate":"activateAccount_activate__50gOT","container":"activateAccount_container__a44wV","title":"activateAccount_title__fdv5Q","success":"activateAccount_success__dmF5q"};